module.exports = __webpack_public_path__ + "static/media/ee_ru_mob_s.0c990d53.png";